import * as types from "../constants/actionTypes";


export const localStorageReducerInitialState = function () {
    //debugger;
    var sRoot = window.localStorage.getItem("root");
    if (sRoot) {
        var oRoot = JSON.parse(sRoot);
        if (oRoot.localStorage) {
            //debugger;
            var oRet;
            try {
                oRet = JSON.parse(oRoot.localStorage);
                return oRet;
            }
            catch (e) {
                //debugger;
                //console.error(e);
            }
        }
    }
    return {
        isLoggedIn: false,
        token: null,
        refreshToken: null,
        tokenLoaded: null,
        tokenExpires: null,
        tokenExpiresIn: null,
        lastLoaded: null,
        appInstanceID: window.serverData.data.appInstanceID
    };
};

export default function localStorageReducer(state = localStorageReducerInitialState(), action) {
    const type = action.type;
    var thisDate = new Date();

    switch (type) {
        case types.USER_AUTHENTICATE_SUCCESS:
            //debugger;
            state = {
                ...state,
                isLoggedIn: true,
                token: action.userData.access_token,
                refreshToken: action.userData.refresh_token,
                tokenLoaded: action.userData.dateLoaded,
                tokenExpires: action.userData.expiresDate,
                tokenExpiresIn: action.userData.expires_in,
                lastLoaded: thisDate,
                appInstanceID: window.serverData.data.appInstanceID
            };
            //debugger;
            break;

        case types.LOGOUT_COMPLETED:
            state = {
                ...state,
                isLoggedIn: false,
                token: null,
                refreshToken: null,
                tokenLoaded: null, 
                tokenExpires: null,
                tokenExpiresIn: null,
                lastLoaded: null,
                appInstanceID: window.serverData.data.appInstanceID
            };
            break;

    }


    return state;
}
